'use strict'
import request from '@/utils/request'
class ChatsimpleService{
    static getchat(query){
        return request({
            url:'/chatsimple/getchat',
            method:'get',
            params:query
        })
    }
}
export default ChatsimpleService